export const izjava2Lookup =
    [
        {
            id: "1", ime: "но размислувам да го променам телото"
        }
    ]